import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

/**
 * AuthInterceptorService
 * Intercepta todas las respuestas HTTP y detecta cuando el token ha expirado.
 * El backend responde con { status: false, code: "ERR_AUTH_0002" } cuando
 * el token ya no es válido. En ese caso, limpia la sesión y redirige al login.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  private isRedirecting = false; // Evita múltiples redirects simultáneos

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const body = event.body;

          // Detectar token expirado: { status: false, code: "ERR_AUTH_0002" }
          // También detectar falta de autorización: status false + message de autorización
          if (body && body.status === false &&
            (body.code === 'ERR_AUTH_0002' || body.code === 'ERR_AUTH_0001')) {

            if (!this.isRedirecting) {
              this.isRedirecting = true;
              this.handleTokenExpired();
            }
          }
        }
      })
    );
  }

  private handleTokenExpired(): void {
    // Guardar clienteId antes de limpiar la sesión
    const clienteId = sessionStorage.getItem('clienteId') || '';

    // Limpiar toda la sesión
    sessionStorage.clear();
    if (clienteId) {
      sessionStorage.setItem('clienteId', clienteId);
    }

    // Notificar al usuario
    Swal.fire({
      icon: 'warning',
      title: 'Sesión expirada',
      text: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
      confirmButtonColor: '#7C1E16',
      confirmButtonText: 'Ir al login',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(() => {
      this.isRedirecting = false;
      // El idCompany ya no se propaga por URL (cliente fijo COMPANY001).
      this.router.navigate(['/auth/login']);
    });
  }
}
